import angular from "angular";
import angularMoment from "angular-moment";
import kalendar from "../kalendar/kalendar";
import angularUib from "angular-ui-bootstrap";
import core from "../core/core.module";
import filters from "angular-filter";

let mod = angular
    .module('dailyReport.component', [angularMoment, kalendar, angularUib, 'chart.js', core, filters])
    .component('dailyReport', {
        template: require('./daily-report.component.html'),
        controller: ['$http', 'moment', 'notifier', 'Auth', '$timeout', '$filter', controller],
        bindings: {
            user: '<'
        }
    });

function controller($http, moment, notifier, Auth, $timeout, $filter) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.statusesList = ['issue', 'refund', 'cancel'];

        $ctrl.date = moment().format('YYYY-MM-DD');

        $ctrl.showOrganizationsTable = Auth.hasRoles(['owner.senior_supervisor']);

        $ctrl.showAgentsTable = Auth.hasRoles(['owner.supervisor', 'customer.supervisor']);

        $ctrl.totalSum = null;

        $ctrl.totalCount = null;

        $ctrl.statusKeys = ['issue', 'refund', 'cancel'];

        $ctrl.statuses = {};

        $ctrl.statusKeys.forEach(function (s) {
            $ctrl.statuses[s] = {
                label: getStatusLabel(s),
                sum: null,
                count: null,
                chart: getChart(s),
            };
        });

        getData();

    };

    function getStatusLabel(type) {
        if (type == 'issue') {
            return 'Оформленные';
        } else if (type == 'refund') {
            return 'Возвращенные';
        } else {
            return 'Отмененные';
        }
    }

    function getChart(type) {
        let colors = {
            'issue': '#11c15f',
            'refund': '#e7c954',
            'cancel': '#ff5555'
        };
        return {
            data: null,
            options: {
                cutoutPercentage: 80,
                legend: {
                    display: false,
                },
                tooltips: {
                    enabled: false,
                }
            },
            dataset: {
                backgroundColor: [colors[type], '#475364'],
                hoverBackgroundColor: [colors[type], '#475364'],
                borderWidth: [0, 0],
                hoverBorderWidth: [0, 0],
            }
        };
    }

    $ctrl.dateChanged = function (dates) {
        $ctrl.date = dates[0];
        getData();
    };

    function getData() {

        $ctrl.loading = true;

        $ctrl.totalCount = null;

        $ctrl.totalSum = null;

        $ctrl.statusKeys.forEach(function (s) {
            $ctrl.statuses[s].sum = null;
            $ctrl.statuses[s].count = null;
            $ctrl.statuses[s].chart.data = null;
        });

        $http
            .get('/reports/get-daily-report', {params: {date: $ctrl.date}})
            .then(
                function (response) {

                    if ($ctrl.showOrganizationsTable) {
                        parseOrganizationsReport(response.data);
                    } else
                        if ($ctrl.showAgentsTable) {
                            parseAgentsReport(response.data);
                        } else {
                            parseUserReport(response.data);
                        }

                    $timeout(function () {
                        $ctrl.loading = false;
                    }, 1000);

                },
                function (error) {
                    $ctrl.loading = false;
                    notifier.errorResponseNotify(error);
                }
            );
    }

    function parseOrganizationsReport(rep) {

        $ctrl.totalCount = 0;

        $ctrl.report = [];

        let totals = {};

        $ctrl.statusKeys.forEach(function (s) {
            totals[s] = {
                sum: 0,
                count: 0
            };
        });

        rep.forEach(function (org) {
            let orgTotals = {};
            $ctrl.statusKeys.forEach(function (s) {
                orgTotals[s] = {
                    sum: 0,
                    count: 0
                };
                org.forEach(function (agent) {
                    orgTotals[s]['sum'] += +agent[s + 'Sum'];
                    orgTotals[s]['count'] += +agent[s + 'Count'];
                    totals[s].sum += +agent[s + 'Sum'];
                    totals[s].count += +agent[s + 'Count'];
                    $ctrl.totalCount += +agent[s + 'Count'];
                });
            });
            $ctrl.report.push({
                totals: orgTotals,
                totalSum: orgTotals['issue'].sum - orgTotals['refund'].sum,
                organizationName: org[0].organization.short_name,
                agents: org
            });
        });

        $ctrl.statusKeys.forEach(function (s) {
            $ctrl.statuses[s].sum = totals[s]['sum'];
            $ctrl.statuses[s].count = totals[s]['count'];
            $ctrl.statuses[s].chart.data = getChartData(totals[s]['count']);
        });

        $ctrl.totalSum = $ctrl.statuses['issue'].sum - $ctrl.statuses['refund'].sum;
    }

    function parseAgentsReport(rep) {

        $ctrl.totalCount = 0;

        for (let i = 0; i < rep.length; i++) {
            $ctrl.totalCount += +rep[i]['allCount'];
        }

        $ctrl.statusKeys.forEach(function (s) {
            let sum = 0;
            let count = 0;
            for (let i = 0; i < rep.length; i++) {
                sum += +rep[i][s + 'Sum'];
                count += +rep[i][s + 'Count'];
            }
            $ctrl.statuses[s].sum = sum;
            $ctrl.statuses[s].count = count;
            $ctrl.statuses[s].chart.data = getChartData(count);
        });

        $ctrl.report = rep;

        $ctrl.totalSum = $ctrl.statuses['issue'].sum - $ctrl.statuses['refund'].sum;

    }

    function parseUserReport(rep) {
        $ctrl.totalCount = rep.length ? rep[0].allCount : 0;
        $ctrl.statusKeys.forEach(function (s) {
            $ctrl.statuses[s].sum = rep.length ? rep[0][s + 'Sum'] : 0;
            $ctrl.statuses[s].count = rep.length ? rep[0][s + 'Count'] : 0;
            $ctrl.statuses[s].chart.data = rep.length ? getChartData(rep[0][s + 'Count']) : [0, 100];
        });
        $ctrl.totalSum = $ctrl.statuses['issue'].sum - $ctrl.statuses['refund'].sum;
    }

    function getChartData(count) {
        if (!count) {
            return [0, 100];
        }
        let p = count * 100 / $ctrl.totalCount;
        p = Math.floor(p);
        return [p, 100 - p];
    }
}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/daily-report/daily-report.component.js